// extracted by mini-css-extract-plugin
export default {"container":"StreamSection_container__id78q"};